import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { getAggregatePurchaseDetail, getCommercialPurchaseDetail, getMortarPurchaseDetail } from '@/service/purchase/reportDetail';
export default function useMortarSaleContrastData(params, type) {
  var loading = ref(false);
  var finished = ref(false);
  var totalData = ref({
    rawMaterialMoney: 0,
    totalSettleValue: 0,
    totalAveragePrice: 0,
    totalFreight: 0,
    totalMoney: 0,
    totalSingular: 0
  });
  var list = ref([]);
  var getDetailAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _list$value, data, _list$value2, _data, _list$value3, _data2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            loading.value = true;
            if (!(type.value === 'aggregate')) {
              _context.next = 9;
              break;
            }
            _context.next = 5;
            return getAggregatePurchaseDetail(params.value);
          case 5:
            data = _context.sent;
            totalData.value = data.totalData;
            (_list$value = list.value).push.apply(_list$value, _toConsumableArray(data.detailPage.list));
            // 数据全部加载完成
            if (data.detailPage.totalRow === list.value.length) {
              finished.value = true;
            }
          case 9:
            if (!(type.value === 'shangTong')) {
              _context.next = 16;
              break;
            }
            _context.next = 12;
            return getCommercialPurchaseDetail(params.value);
          case 12:
            _data = _context.sent;
            totalData.value = _data.totalData;
            (_list$value2 = list.value).push.apply(_list$value2, _toConsumableArray(_data.detailPage.list));
            // 数据全部加载完成
            if (_data.detailPage.totalRow === list.value.length) {
              finished.value = true;
            }
          case 16:
            if (!(type.value === 'mortar')) {
              _context.next = 23;
              break;
            }
            _context.next = 19;
            return getMortarPurchaseDetail(params.value);
          case 19:
            _data2 = _context.sent;
            totalData.value = _data2.totalData;
            (_list$value3 = list.value).push.apply(_list$value3, _toConsumableArray(_data2.detailPage.list));
            // 数据全部加载完成
            if (_data2.detailPage.totalRow === list.value.length) {
              finished.value = true;
            }
          case 23:
            // 加载状态结束
            loading.value = false;
            _context.next = 29;
            break;
          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](0);
            params.value.pageNumber -= 1;
          case 29:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 26]]);
    }));
    return function getDetailAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var onLoad = function onLoad() {
    params.value.pageNumber += 1;
    getDetailAsync();
  };
  return [totalData, list, loading, finished, getDetailAsync, onLoad];
}